import React from 'react'

const capitalizeWords = (str) =>
    str
        .toLowerCase()
        .replace(/\b\w/g, (char) => char.toUpperCase());

const FilterCard = ({ className, onClick, horizental, Icon, title, titleClass }) => {
    return (
        <div className={`${className} border-2 border-white w-fit px-4 py-2 rounded-md md:rounded-lg hover:cursor-pointer flex flex-col gap-2 items-center justify-center text-center  `} onClick={onClick} >
            {/* {Icon && (
                <div className="card_icons">
                    <Icon style={{ width: '20px' }} />
                </div>
            )} */}
            <h2 className={`font-quicksand md:text-base text-xs font-bold capitalize`}>
                {capitalizeWords(title)}
            </h2>
        </div>
    )
}

export default FilterCard
